
import AppLayoutVue from "@/Layouts/AppLayout.vue";
import { computed, defineComponent, PropType } from "vue";
import Card from "@/Components/General/Card.vue";
import { useForm } from "@inertiajs/inertia-vue3";
import dayjs from "dayjs";
import Multiselect from "@/Components/General/Multiselect.vue";
import Button from "@/Components/Buttons/Button.vue";
import { BarChart } from "vue-chart-3";
import { Chart, ChartData, BarController, CategoryScale, LinearScale, ArcElement, BarElement, ChartOptions, Tooltip, Title } from "chart.js";
import Category from "@/types/Category";
import ValidationFormErrors from "@/Components/Forms/ValidationFormErrors.vue";
import SvgIcon from "@jamescoyle/vue-icon";
import { mdiLoading } from "@mdi/js";
import CategorySelect from "@/Components/Forms/CategorySelect.vue";
import StatisticsNav from "@/Components/Reports/StatisticsNav.vue";

Chart.register(BarController, CategoryScale, LinearScale, BarElement, Tooltip, Title);

interface SaleData {
  hour: number;
  count: number;
}

export default defineComponent({
  layout: AppLayoutVue,
  props: {
    data: {
      type: Array as PropType<SaleData[]>,
      required: false,
    },
    date_from: {
      type: String,
      required: false,
    },
    date_to: {
      type: String,
      required: false,
    },
    exclude_categories: {
      type: Array as PropType<number[]>,
      required: true,
    },
    exclude_web_orders: {
      type: Boolean,
      default: () => true,
    },
    categories: {
      type: Array as PropType<Category[]>,
      required: true,
    }
  },
  setup(props) {
    const form = useForm({
      date_from: props.date_from ?? dayjs().subtract(1, "month").startOf("month").format("YYYY-MM-DD"),
      date_to: props.date_to ?? dayjs().subtract(1, "month").endOf("month").format("YYYY-MM-DD"),
      exclude_categories: props.exclude_categories,
      exclude_web_orders: props.exclude_web_orders,
    });

    const submit = () => {
      console.log(form);
      form.get(route(route().current() ?? ""));
    }

    const chartData = computed((): ChartData<"bar"> => {
      return {
        labels: props.data?.map((data) => `${data.hour}:00-${data.hour + 1}:00`),
        datasets: [
          {
            label: "Antall ordre",
            data: props.data?.map((data) => data.count) ?? [],
            backgroundColor: "hsl(197, 57%, 31%)",
          }
        ],
      }
    });

    const chartOptions: ChartOptions = {
      animation: {
        duration: 750,
      },
      plugins: {
        title: {
          display: true,
          text: "Ordre per time på dagen",
        }
      },
      scales: {
        y: {
          beginAtZero: true,
        }
      },
      locale: "nb-NO",
      maintainAspectRatio: false,
    }

    return {
      form,
      submit,
      chartData,
      chartOptions,
      icons: {
        loading: mdiLoading,
      }
    };
  },
  components: { Card, Multiselect, Button, BarChart, ValidationFormErrors, SvgIcon, CategorySelect, StatisticsNav }
});
